import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { BTWN_100_500_METER, BTWN_4_6_HR, BTWN_500_1_METER, BTWN_6_8_HR, FILE_NAME_VALIDATION_ERROR, MORE_THAN_8_HR, ROAD_PHOTO, WITHIN_100_METER } from '../../../../common/constants';
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { Container, Card, CardContent, Button, RadioGroup, Radio, ToggleButton, ToggleButtonGroup, FormControlLabel, Box, Typography, Grid } from '@mui/material';
import { PROD } from '../../../../common/constants';
import { downloadDocument, uploadDocument } from '../../../../common/Utils';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { fileNameValidation } from "../../../../common/commonValidations";
import { useTranslation } from "react-i18next";
import { ArrowBackIosNewIcon, ArrowForwardIosIcon } from "../../../../common/icons";

const agencyChooseFileUpload = {
    backgroundColor: "#D9D9D9",
    borderRadius: "3vw",
    color: "#000000",
    marginLeft: "8vw",
    marginTop: "-7vh",
    height: "6vh",
    width: "11vw",
}



const LLEPowerDetails = () => {
    const { t, i18n } = useTranslation();
    const [prevScreenData, setPrevScreenData] = useState();
    const [backButtonData, setBackButtonData] = useState();
    const [roadConnectivity, setRoadConnectivity] = useState("Adjacent to an existing bitumen/block road");
    const [optedLocationPowerConnectionDistance, setOptedLocationPowerConnectionDistance] = useState(WITHIN_100_METER);
    const [isDadicatedTransformerLoaded, setIsDadicatedTransformerLoaded] = useState(true);
    const [daytimePowerAvailability, setDaytimePowerAvailability] = useState(MORE_THAN_8_HR);
    const [isAlternatePowerSupplyAvailable, setIsAlternatePowerSupplyAvailable] = useState(true);

    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [isRoadConnectivityValid, setIsRoadConnectivityValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState({
        roadDocError: ''
    });
    const navigate = useNavigate();
    const location = useLocation();
    const [roadPhotoFileName, setRoadPhotoFileName] = useState();
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [documentDetailsArr, setDocumentDetailsArr] = useState([]);
    const [documentDetailsObj, setDocumentDetailsObj] = useState({
        id: null,
        documentType: null,
        documentName: null, //
        documentBlobName: null, //
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: "lle",
        stakeholderDetailId: null,
        isActive: 1
    });

    useEffect(() => {
        setBackButtonData(location.state.data);
        if (backButtonData) {
            setIsDadicatedTransformerLoaded(backButtonData.isDadicatedTransformerLoaded ? backButtonData.isDadicatedTransformerLoaded : true);
            setDaytimePowerAvailability(backButtonData.daytimePowerAvailability ? backButtonData.daytimePowerAvailability : MORE_THAN_8_HR);
            setOptedLocationPowerConnectionDistance(backButtonData.optedLocationPowerConnectionDistance ? backButtonData.optedLocationPowerConnectionDistance : WITHIN_100_METER);
            setIsAlternatePowerSupplyAvailable(backButtonData.isAlternatePowerSupplyAvailable ? backButtonData.isAlternatePowerSupplyAvailable : true)
            setRoadConnectivity(backButtonData.roadConnectivity ? backButtonData.roadConnectivity : "Adjacent to an existing bitumen/block road");
            setRoadPhotoFileName(backButtonData?.documents?.[0]?.documentType === "RoadPhoto" ? backButtonData?.documents?.[0]?.documentName : backButtonData?.documents?.[1]?.documentType === "RoadPhoto" ? backButtonData?.documents?.[1]?.documentName : backButtonData?.documents?.[2]?.documentType === "RoadPhoto" ? backButtonData?.documents?.[2]?.documentName : backButtonData?.documents?.[3]?.documentType === "RoadPhoto" ? backButtonData?.documents?.[3]?.documentName : backButtonData?.documents?.[4]?.documentType === "RoadPhoto" ? backButtonData?.documents?.[4]?.documentName : backButtonData?.documents?.[5]?.documentType === "RoadPhoto" ? backButtonData?.documents?.[5]?.documentName : "")
        }


    }, [backButtonData]);

    useEffect(() => {
        setPrevScreenData(location.state.data)

        setDocumentDetailsArr(location.state.data?.documents)
        setSelectedApplicant(location.state.data.applicantType);

    }, [prevScreenData]);
    const isRoadConnectivityValidOnchange = (e) => {
        if (e.target.value === "true") {
            setIsRoadConnectivityValid(true)

        } else {
            setIsRoadConnectivityValid(false)

        }

    }
    const onApplicantClick = (e) => {
        e.preventDefault();
        setSelectedApplicant(e.target.value)
    }
    //useEffect(() => {
    //    if (selectedFile) {
    //        getDocumentUploadDetails();
    //    }
    //}, [selectedFile]);

    //useEffect(() => {
    //    if (documentUploadDetails) {
    //        setDocumentDetailsObj({
    //            ...documentDetailsObj,
    //            documentName: documentUploadDetails?.blobResponse?.fileName,
    //            documentBlobName: documentUploadDetails?.blobResponse?.blobFileName
    //        });
    //    }
    //}, [documentUploadDetails]);

    //useEffect(() => {
    //    if (documentDetailsObj.documentBlobName) {
    //        let tempArr = documentDetailsArr.filter((item) => item.documentType !== documentDetailsObj.documentType)
    //        tempArr?.push(documentDetailsObj)
    //        setDocumentDetailsArr(tempArr);
    //    }

    //}, [documentDetailsObj.documentBlobName]);

    //const getDocumentUploadDetails = () => {
    //    const formData = new FormData();
    //    formData.append("file", selectedFile);
    //    formData.append("fileName", selectedFile.name);
    //    formData.append("containerName", "stakeholder");
    //    apiClient
    //        .post(
    //            UPLOAD_DCUMENT,
    //            formData,
    //            {
    //                headers: {
    //                    AuthKey: authKey,
    //                },
    //            }
    //        )
    //        .then((response) => {
    //            setDocumentUploadDetails(response.data);
    //        })

    //        .catch(function (error) {
    //            console.log(error);
    //        });

    //}
    const deleteDocument = (blobFileName, documentType) => {
        let existingData = documentDetailsArr.filter((item) => item.documentType === documentType && item.documentBlobName === blobFileName);
        let tempArr = documentDetailsArr.filter((item) => item.documentBlobName !== blobFileName);
        if (existingData && existingData[0]) {
            if (existingData[0].id) {
                existingData[0].isActive = 0;
                tempArr?.push(existingData[0]);
            }
        }
        setDocumentDetailsArr(tempArr);
    };
    const onClickDocument = (e, blobFileName, documentName) => {
        e.preventDefault();
        downloadDocument(blobFileName, documentName, null);
    };
    const allowedTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];
    const onUploadDocument = (e, type) => {
        if (allowedTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].name.split('.').length > 2) {
            setErrorMessage({
                ...errorMessage,
                roadDocError: "Double extension file detected",
            });
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setErrorMessage({
                ...errorMessage,
                roadDocError: "The file should be less than 5MB",
            });

        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setErrorMessage({
                ...errorMessage,
                roadDocError: FILE_NAME_VALIDATION_ERROR,
            });

        }
        else {
            setErrorMessage({ ...errorMessage, roadDocError: " " });
            setSelectedFile(e.target.files[0]);
            setDocumentDetailsObj({
                ...documentDetailsObj,
                documentType: type,
                stakeholderDetailId: null,
            })
        }


        if (type === ROAD_PHOTO) {
            setRoadPhotoFileName(e.target.files[0].name)
        }
        uploadDocument(e.target.files[0], type, callbackUpload);
    };
    const callbackUpload = (response, type) => {
        setDocumentUploadDetails(response);
        var document = {
            id: null,
            documentType: type,
            documentName: response?.blobResponse?.fileName,
            documentBlobName: response?.blobResponse?.blobFileName,
            documentPath: null,
            documentContainerName: "stakeholder",
            stakeholderType: "LLE",
            //stakeholderDetailId: props.stakeholderDetailId,
            isActive: 1
        }
        var tempArr = documentDetailsArr;
        tempArr.push(document);
        setDocumentDetailsArr(tempArr);
    }
    const onSubmit = (e) => {
        e.preventDefault();
        const dataForApi = {
            ...prevScreenData,
            "optedLocationPowerConnectionDistance": optedLocationPowerConnectionDistance,
            "roadConnectivity": roadConnectivity,
            "daytimePowerAvailability": daytimePowerAvailability,
            "documents": documentDetailsArr
        }
        let roadDoc = documentDetailsArr && documentDetailsArr.filter((item) => item.documentType === ROAD_PHOTO && item.isActive == 1);
        // if (roadDoc.length == 0) {
        //     setErrorMessage({ roadDocError: "Please upload road document" });
        // }
        // else {
        navigate(getLocalStorageItem('id_token') ? "/registrationHome/preregistration/llemandatorypage" : "/preregistration/llemandatorypage", { state: { data: dataForApi } });
//  }
    }

    const isDadicatedTransformerLoadedOnChange = (e) => {
        if (e.target.value == "true") {
            setIsDadicatedTransformerLoaded(true)
        } else {
            setIsDadicatedTransformerLoaded(false)
        }
    }
    const onDaytimePowerAvailabilityChange = (e) => {
        setDaytimePowerAvailability(e.target.value)
    }
    const optedLocationPowerConnectionDistanceChnage = (e) => {
        setOptedLocationPowerConnectionDistance(e.target.value)
    }
    const roadConnectivityChange = (e) => {
        setRoadConnectivity(e.target.value)
    }
    const isAlternatePowerSupplyAvailableOnChange = (e) => {
        if (e.target.value) {
            setIsAlternatePowerSupplyAvailable(true)
        } else {
            setIsAlternatePowerSupplyAvailable(false)
        }
    }


    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG08</p>}
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {t('preReg.informationAboutOptedLocation')}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton disabled value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton disabled value="SHG/Co-opetative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                            <ToggleButton disabled value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.roadConnectivity')}
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    {t('preReg.roadConnectivityDescrip')}
                                </Typography>
                                <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                                    {t('preReg.optedPlotIs')}
                                </Typography>
                                <RadioGroup
                                    defaultValue="Adjacent to an existing bitumen/block road"
                                    name="Opted_plot"
                                >
                                    <FormControlLabel value="Adjacent to an existing bitumen/block road" control={<Radio checked={roadConnectivity === "Adjacent to an existing bitumen/block road"} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToBitumenBlockRoad')} />
                                    <FormControlLabel value="Adjacent to an existing motorable gravel road" control={<Radio checked={roadConnectivity === "Adjacent to an existing motorable gravel road"} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToMotorableGravelRoad')} />
                                    <FormControlLabel value="Requires additional road development less than 500 meters" control={<Radio checked={roadConnectivity === "Requires additional road development less than 500 meters"} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.requireAdditionalRoad')} />
                                </RadioGroup>
                                <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                                    {t('preReg.powerConnectivity11kvline')}
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    {t('preReg.distanceFromDistribution')}
                                </Typography>
                                <Typography variant="caption" style={{ fontStyle: "italic" }}>Upload Photo showing approach road of the opted plot</Typography>
                                {documentDetailsArr?.filter(item => item.documentType === ROAD_PHOTO && item.isActive === 1).map(item => (
                                    <div className="chooseFile_storage">
                                        <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                                        <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                                            onClick={() => deleteDocument(item.documentBlobName, item.documentType)}>
                                            <DeleteIcon color='error' fontSize='inherit' />
                                        </IconButton>
                                    </div>
                                ))
                                }
                                {(documentDetailsArr)?.filter(item => item.documentType === ROAD_PHOTO && item.isActive === 1).length == 0 ?
                                    <label className="chooseFile_storage">
                                        <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" name="uploadedfile2"
                                            style={{ display: "none" }}
                                            onChange={(e) => onUploadDocument(e, ROAD_PHOTO)} />
                                        {t('preReg.uploadFile')}
                                    </label> : null}
                                <div className='mandatory_field'>{errorMessage.roadDocError}</div>
                                <Typography variant="subtitle2" fontSize="1.8vh" align="right" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                                    {t('preReg.powerConnectionAvailable')}
                                </Typography>
                                <RadioGroup
                                    defaultValue={WITHIN_100_METER}
                                    name="power-connection"
                                >
                                    <FormControlLabel value={WITHIN_100_METER} control={<Radio checked={optedLocationPowerConnectionDistance === WITHIN_100_METER} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.within100mtr')} />
                                    <FormControlLabel value={BTWN_100_500_METER} control={<Radio checked={optedLocationPowerConnectionDistance === BTWN_100_500_METER} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn100_500mtr')} />
                                    <FormControlLabel value={BTWN_500_1_METER} control={<Radio checked={optedLocationPowerConnectionDistance === BTWN_500_1_METER} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn500mtr_1km')} />
                                </RadioGroup>
                                <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.daytimePowerAvailability')}
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    {t('preReg.powerAvailabilityDescrip')}
                                </Typography>
                                <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                                    {t('preReg.powerAvailableFor')}
                                </Typography>
                                <RadioGroup
                                    defaultValue={MORE_THAN_8_HR}
                                    name="day-time-power"
                                >
                                    <FormControlLabel value={MORE_THAN_8_HR} control={<Radio checked={daytimePowerAvailability === MORE_THAN_8_HR} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.moreThan8hour')} />
                                    <FormControlLabel value={BTWN_6_8_HR} control={<Radio checked={daytimePowerAvailability === BTWN_6_8_HR} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn6_8hour')} />
                                    <FormControlLabel value={BTWN_4_6_HR} control={<Radio checked={daytimePowerAvailability === BTWN_4_6_HR} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn4_6hour')} />
                                </RadioGroup>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => (navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/llelandSubCategory' : '/preregistration/llelandSubCategory', { state: { data: prevScreenData } }))}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" endIcon={<ArrowForwardIosIcon />} onClick={(e) => onSubmit(e)}>{t('preReg.next')}</Button>
                </Box>
            </Container>

        </>
    );
}

export default LLEPowerDetails;
